import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import {
  AvForm,
  AvField,
} from 'availity-reactstrap-validation';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import Lib from '../../../commons/lib';

// 0 -> Felvitel
// 1 -> módosítás
let _muvelet = 0;
let _modositoObj = null;

class FunkcioJogalapOsszerendeles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // ['QUERY', 'LOAD', 'DATA', 'NETW', 'TABL']
      currentStatusBaseTable: 'LOAD',
      modalNezet: false,
      modalFelvitel: false,
      modalTorles: false,
      dataLoaded: false,
      dataFailed: false,
      baseJson: [],
      aktivJogalap: [],
      aktivFunkcio: [],
      /*
       *  FORM VALUES
       */
      funkcioid: '',
      jogalapid: '',
      statusz: '',

      statuszok: [],
      statuszOptions: [],
      filterOptions: {},
      viewObj: null,
    };

    this.updateTable = this.updateTable.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.updateTable();
      }
    }
  }

  getAktivFunkcio = () => {
    if (Lib.KeyCloak.hasRole(this.props.globals.keycloak, ['GDPR_JOGALAP'])) {
      Services.listFunkcio((err, res) => {
        if (!err) {
          let resOptions = res[0].map(e => <option key={e.id} value={e.id}>{e.label}</option>);
          this.setState({ aktivFunkcio: resOptions });
        }
      });
    }
  }

  getAktivJogalap = () => {
    if (Lib.KeyCloak.hasRole(this.props.globals.keycloak, ['GDPR_JOGALAP'])) {
      Services.listAktivJogalap((err, res) => {
        if (!err) {
          let resOptions = res[0].map(e => <option key={e.id} value={e.id}>{e.nev + ' [' + e.kod + '] - ' + e.elevules + ' év'}</option>);
          this.setState({ aktivJogalap: resOptions });
        }
      });
    }
  }

  updateTable = () => {
    this.setState({
      currentStatusBaseTable: 'LOAD'
    });
    Services.listOsszerendeles((err, res) => {
      if (err) {
        this.setState({
          currentStatusBaseTable: 'NETW'
        });
      } else {
        let filters = {};
        let options = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });

        this.setState({
          baseJson: res[0].list,
          currentStatusBaseTable: res[0].list.length > 0 ? 'TABL' : 'DATA',
          statuszok: res[0].statusz,
          statuszOptions: options,
          filterOptions: filters,
        });
      }
    });
  }

  fillModositoObj = () => {
    this.setState({ modifyDataLoaded: false, modfiyDataFailed: false });
    Services.getOsszerendeles(this._currentEditId, (err, res) => {
      if (err) {
        this.setState({ modifyDataLoaded: true, modfiyDataFailed: true });
      } else {
        this.setState({
          funkcioid: res[0].funkcioid,
          jogalapid: res[0].jogalapid,
          statusz: res[0].statusz
        }, () => {
          this.toggleModositas();
        });
      }
    });
  }

  clearModositoObj = () => {
    _modositoObj = {
      id: '',
      ev: '',
      tipus: '',
      mertek: '',
      statusz: 'AKTIV',
    };
  }

  toggleNezet = () => {
    this.setState({ modalNezet: !this.state.modalNezet });
  }

  toggleModositas = () => {
    this.setState({
      modalFelvitel: !this.state.modalFelvitel
    });
  }

  toggleFelvitel = () => {
    this.setState({
      funkcioid: '',
      jogalapid: '',
      statusz: '',
      modalFelvitel: !this.state.modalFelvitel
    });
  }

  toggleTorles = () => {
    this.setState({ modalTorles: !this.state.modalTorles });
  }

  handleEditClick = (id) => {
    _muvelet = 1;
    this._currentEditId = id;
    this.getAktivFunkcio();
    this.getAktivJogalap();
    this.fillModositoObj();
  }

  handleNewClick = () => {
    _muvelet = 0;
    this.clearModositoObj();
    this.getAktivFunkcio();
    this.getAktivJogalap();
    this.toggleFelvitel();
    this.setState({ statusz: 'AKTIV' });
  }

  handleDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTorles();
  }

  handleViewClick = (id) => {
    this._currentViewId = id;
    this.viewOsszerendeles();
  }

  iconFormatter = (cell, row) => {
    return (
      <div>
        { Lib.KeyCloak.hasHigherRole(this.props.globals.keycloak, 'GDPR_JOGALAP', 'LEK') && (
          <React.Fragment>
            <Button className="icon-eye table-action-icon" id={'action-view-' + cell} onClick={() => this.handleViewClick(cell)} />
            <UncontrolledTooltip placement="left" target={'action-view-' + cell} delay={10}>
              Megtekintés
            </UncontrolledTooltip>
          </React.Fragment>
        )}
        { Lib.KeyCloak.hasHigherRole(this.props.globals.keycloak, 'GDPR_JOGALAP', 'KARB') && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-edit-' + cell} onClick={() => this.handleEditClick(cell, row)} />
            <UncontrolledTooltip placement="left" target={'action-edit-' + cell} delay={10}>
              Módosítás
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-delete-' + cell} onClick={() => this.handleDeleteClick(cell)} />
            <UncontrolledTooltip placement="left" target={'action-delete-' + cell} delay={10}>
              Törlés
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  felhasznalvaFormatter = (cell) => {
    return cell ? 'Igen' : 'Nem';
  }

  viewOsszerendeles = () => {
    Services.viewOsszerendeles(this._currentViewId, (err, res) => {
      if (!err) {
        this.setState({ viewObj: res[0] }, () => { this.toggleNezet(); });
      }
    });
  }

  addOsszerendeles = () => {
    let submitObj = {
      funkcioid: this.state.funkcioid,
      jogalapid: this.state.jogalapid,
      statusz: this.state.statusz
    };

    Services.addOsszerendeles(submitObj, (err) => {
      if (!err) {
        this.toggleFelvitel();
        this.updateTable();
        this.props.globals.addSuccess('Összerendelés felvéve!');
      }
    });
  }

  updateOsszerendeles = () => {
    let submitObj = {
      id: this._currentEditId,
      funkcioid: this.state.funkcioid,
      jogalapid: this.state.jogalapid,
      statusz: this.state.statusz
    };

    Services.editOsszerendeles(submitObj, (err) => {
      if (!err) {
        this.toggleFelvitel();
        this.updateTable();
        this.props.globals.addSuccess('Összerendelés módosítva!');
      }
    });
  }

  deleteOsszerendeles = (id) => {
    this.toggleTorles();
    Services.deleteOsszerendeles(id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Összerendelés törölve!');
      }
    });
  }

  filterType = (cell) => {
    // just return type for filtering or searching.
    return cell.caption;
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  statusFormatter = (cell) => {
    let statusz = this.state.statuszok.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  renderBaseTable = () => {
    const pagination = true;
    const options = {
      sizePerPage: 5,
      paginationShowsTotal: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '50', value: 50 },
        { text: '100', value: 100 }
      ],
    };

    return (
      <BootstrapTable data={this.state.baseJson} pagination={pagination} options={options}>
        <TableHeaderColumn
          dataField="funkcio"
          tdStyle={{ whiteSpace: 'normal' }}
          filter={{ type: 'TextFilter', delay: 400, placeholder: 'Keresés...' }}
        >
            Funkció
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="jogalap"
          tdStyle={{ whiteSpace: 'normal' }}
          filter={{ type: 'TextFilter', delay: 400, placeholder: 'Keresés...' }}
        >
            Jogalap
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="statusz"
          dataFormat={this.statusFormatter}
          tdStyle={{ whiteSpace: 'normal' }}
          filter={{ type: 'SelectFilter', options: this.state.filterOptions, placeholder: 'Összes', condition: 'eq' }}
          dataAlign="center"
        >
            Státusz
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="id"
          isKey
          dataFormat={this.iconFormatter}
          width="100"
        >
            Műveletek
        </TableHeaderColumn>
      </BootstrapTable>);
  }

  renderAdatok = (id) => {
    return (
      <div>
        <h6>
          Jogalap információ:
        </h6>
        <b>
          Kód:
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.jogalapkod}
        <br />
        <b>
          Megnevezés:
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.jogalapnev}
        <br />
        <b>
          Szöveg:
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.jogalapszoveg}
        <br />
        <b>
          Jogszabály hivatkozás:
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.jogalaphivatkozas}
        <br />
        <b>
          Státusz:
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.statusz}
        <br />
        <b>
          Elévülési idő:
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.jogalapelevules + ' év'}
        <br />
        <br />
        <h6>
          Funkció információ:
        </h6>
        <b>
          Kód:
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.funkciokod}
        <br />
        <b>
          Megnevezés:
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.funkcionev}
        <br />
        <b>
          Típus:
        </b>
        {this.state.viewObj && ' ' + this.state.viewObj.funkciotipus}
        <br />
      </div>
    );
  }

  render() {
    return (
      <div>
        { Lib.KeyCloak.hasHigherRole(this.props.globals.keycloak, 'GDPR_JOGALAP', 'KARB') && (
          <div className="row">
            <div className="col-sm-12">
              <Button
                className="pull-left table-new-button"
                color="primary"
                onClick={this.handleNewClick}
              >
                Új összerendelés
              </Button>
            </div>
          </div>
        )}
        {{
          QUERY: (<QueryEmptyState
            hasImage
          />),
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Próbálj más előszűrést vagy vigyél fel új adatokat!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.updateTable()}
          />),
          TABL: (this.renderBaseTable())
        }[this.state.currentStatusBaseTable]}
        <Modal isOpen={this.state.modalNezet} toggle={this.toggleNezet} className={this.props.className} backdrop="static">
          <ModalHeader>
            Megtekintés
          </ModalHeader>
          <ModalBody>{this.state.modalNezet ? this.renderAdatok(this._currentViewId) : <div />}</ModalBody>
          <ModalFooter> <Button type="button" color="primary" onClick={this.toggleNezet} className="btn-cursor-pointer" >Vissza</Button></ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className} backdrop="static">
          <ModalHeader>
            Törlés
          </ModalHeader>
          <ModalBody>
            Valóban törölni kívánja a kiválasztott tételt?
          </ModalBody>
          <ModalFooter>
            <Button className="btn-cursor-pointer" color="primary" onClick={() => this.deleteOsszerendeles(this._currentDeleteId)}>
              OK
            </Button>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleTorles}>
              Mégsem
            </Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalFelvitel} toggle={this.toggleFelvitel} className={this.props.className} backdrop="static" >
          <AvForm onValidSubmit={_muvelet === 0 ? this.addOsszerendeles : this.updateOsszerendeles}>
            {_muvelet === 0 ? <ModalHeader>Új összerendelés rögzítése</ModalHeader> : <ModalHeader>Meglévő összerendelés módosítása</ModalHeader> }
            <ModalBody>
              <div className="row">
                <div className="col-md-12">
                  <AvField
                    type="select"
                    required
                    name="funkcioid"
                    id="funkcioid"
                    label="Funkció: *"
                    errorMessage="Kötelező mező!"
                    value={this.state.funkcioid}
                    onChange={this.handleInputChange}
                  >
                    <option disabled value="">
                      Válassz funkciót...
                    </option>
                    {this.state.aktivFunkcio}
                  </AvField>
                </div>
                <div className="col-md-12">
                  <AvField
                    type="select"
                    required
                    name="jogalapid"
                    id="jogalapid"
                    label="Jogalap: *"
                    errorMessage="Kötelező mező!"
                    value={this.state.jogalapid}
                    onChange={this.handleInputChange}
                  >
                    <option disabled value="">
                      Válassz jogalapot...
                    </option>
                    {this.state.aktivJogalap}
                  </AvField>
                </div>
                <div className="col-md-12">
                  <AvField
                    type="select"
                    required
                    name="statusz"
                    id="statusz"
                    label="Státusz: *"
                    errorMessage="Kötelező mező!"
                    value={this.state.statusz}
                    onChange={this.handleInputChange}
                  >
                    {this.state.statuszOptions}
                  </AvField>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="primary">
                Mentés
              </Button>
              {' '}
              <Button type="button" color="secondary" onClick={this.toggleFelvitel}>
                Mégse
              </Button>
            </ModalFooter>
          </AvForm>
        </Modal>
      </div>
    );
  }
}

export default FunkcioJogalapOsszerendeles;
